import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { SftpKey } from '@app/sftp-mgmt/models/sftp-key';
import { Client } from '@app/core/models/client';
import { MessageDialogComponent } from '@app/shared/message-dialog/message-dialog.component';
import { SftpUser } from '@app/sftp-mgmt/models/sftp-user';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { HelpInfoPopupComponent } from '../../../shared/help-info-popup/help-info-popup.component';
import { SftpNewKeyComponent } from '../sftp-new-key/sftp-new-key.component';
import { SftpKeyListElementComponent } from '../sftp-key-list-element/sftp-key-list-element.component';
import { MessageDialogComponent as MessageDialogComponent_1 } from '../../../shared/message-dialog/message-dialog.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'rn-sftp-key-list',
    templateUrl: './sftp-key-list.component.html',
    styleUrls: ['./sftp-key-list.component.scss'],
    standalone: true,
    imports: [SpinnerComponent, HelpInfoPopupComponent, SftpNewKeyComponent, SftpKeyListElementComponent, MessageDialogComponent_1, DatePipe]
})
export class SftpKeyListComponent implements OnChanges {
  @Input() client: Client;
  @Input() sftpUser: SftpUser;
  @Input() resultsDialog: MessageDialogComponent;
  @Input() sftpKeys: SftpKey[];
  @Input() hasKeyLoadingError: boolean;
  @Input() hasUserLoadingError: boolean;
  @Output() onDeleteConfirmed = new EventEmitter<number>();
  @Output() onSaveClicked = new EventEmitter<string>();

  showAddKeyComponent: boolean = true;
  keyIdToDelete: number;
  showSFTPUserDetails: boolean = false;

  @ViewChild('confirmationDialog', {static: true}) confirmationDialog: MessageDialogComponent;

  constructor() {
  }

  ngOnChanges(): void {
    this.showAddKeyComponent = !this.hasKeys();
  }

  isLoadingKeys(): boolean {
    return !this.hasKeyLoadingError && !this.sftpKeys;
  }

  hasKeys(): boolean {
    return this.sftpKeys?.length > 0;
  }

  isLoadingUser(): boolean {
    return !this.hasUserLoadingError && !this.sftpUser;
  }

  hasUser(): boolean {
    return !!this.sftpUser;
  }

  promptForDeleteKey(keyId: string): void {
    this.keyIdToDelete = Number(keyId);
    this.confirmationDialog.showMessage('Are you sure you want to delete this key?')
  }

  handleOnSaveClicked(key: string) {
    this.onSaveClicked.emit(key);
  }

  toggleAddKeyComponent() {
    this.showAddKeyComponent = !this.showAddKeyComponent;
  }
}
